import { DsLibMainMenuSectionInterface } from '@sixense/ds-lib-main-menu';

export const DS_DOCS_MENU: DsLibMainMenuSectionInterface = {
  title: 'menu.docs',
  expandable: false,
  expanded: false,
  icon: 'folder',
  link: {
    title: '',
    url: 'projects/{id}/docs',
    disabled: false,
  },
  rights: [],
};
